<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AlertDelivery',
    props: {
        restaurant: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapGetters({
            isDelivery: 'order/isDelivery',
        }),
        location() {
            return this.restaurant && this.restaurant.id ? this.restaurant.location : null
        },
    },
}
</script>

<template lang="pug">
transition(name="alert")
    .alert-wrapper
        .alert.alert-info(v-if="isDelivery")
            icon.mr-4(icon="fa-solid fa-shopping-bag")
            span.content-html(v-html="$t('alerts.pickup')")
            strong &nbsp;{{location}}
</template>
